export default __webpack_public_path__ + "static/media/04b_fold-20.8aa49447.mp4";